import React from "react";
import UserEngagementAnalytics from "./UserEngagementAnalytics";
import UserEngagementAnalyticsContextProvider from "./UserEngagementAnalyticsContextProvider";

const UserEngagementAnalyticsWrapper = () => {
  return (
    <UserEngagementAnalyticsContextProvider>
      <UserEngagementAnalytics />
    </UserEngagementAnalyticsContextProvider>
  );
};

export default UserEngagementAnalyticsWrapper;
